exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Geopin__geopin___2Gb2J{border:1px solid #606062;width:9px;height:9px;border-radius:50%;display:inline-block;position:relative;margin-right:5px;margin-bottom:2px}.Geopin__geopin___2Gb2J:before{width:3px;top:2px;right:2px;border-radius:50%}.Geopin__geopin___2Gb2J:after,.Geopin__geopin___2Gb2J:before{content:\"\";position:absolute;height:3px;background-color:#606062}.Geopin__geopin___2Gb2J:after{width:1px;bottom:-3px;left:3px}", ""]);

// exports
exports.locals = {
	"geopin": "Geopin__geopin___2Gb2J"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"sourceMap":true,"plugins":[null]}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/Geopin.less
// module id = ./node_modules/css-loader/index.js?{"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"sourceMap":true,"plugins":[null]}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/Geopin.less
// module chunks = 0